import FuncionService from 'src/modules/funcion/funcionService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'FUNCION_VIEW';

const funcionViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: funcionViewActions.FIND_STARTED,
      });

      const record = await FuncionService.find(id);

      dispatch({
        type: funcionViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: funcionViewActions.FIND_ERROR,
      });

      getHistory().push('/funcion');
    }
  },
};

export default funcionViewActions;
